// simple-peer and its readable-stream dependency reach for node globals.
// webpack's ProvidePlugin used to supply them; Vite does not, so hand them
// over here. Must be imported before anything that pulls in simple-peer.
//
// These resolve to the userland browser shims, not node builtins. A node:
// specifier would be externalised for the browser and fail the build, which
// is why Sonar's S7772 is excluded for this file. `global` is a bare identifier
// rather than an import, so it is handled by define in vite.config.mts.
import process from 'process';
import { Buffer } from 'buffer';

const globals = globalThis as typeof globalThis & {
  process?: unknown;
  Buffer?: unknown;
};

globals.process ??= process;
globals.Buffer ??= Buffer;
